import React, { ChangeEvent, FC, memo, useCallback, useEffect, useState } from 'react'
import { FeedbackFormContainer } from './feedback-form-container';
import { FeedbackFormTextarea } from './feedback-form-texarea';
import { FeedbackFormSubmitButton } from './feedback-form-submit-button';
import { useTheme } from 'styled-components';

interface FeedbackFormProps {
  actualValue?: string;
  handleSubmit: (newValue: string) => void;
}

export const FeedbackForm: FC<FeedbackFormProps> = memo(({
  actualValue,
  handleSubmit
}) => {
  const theme = useTheme();
  const [value, setValue] = useState(actualValue || '');

  const handleChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
    setValue(() => e.target.value);
  }, []);

  const handleSubmitClick = useCallback(() => {
    handleSubmit(value);
  }, [handleSubmit, value]);

  return (
    <FeedbackFormContainer className="feedback_text voa_feedback_internal_container">
      <FeedbackFormTextarea
        placeholder='Enter feedback'
        value={value}
        onChange={handleChange}
        className="voa_feedback_text_area"
      />
      <FeedbackFormSubmitButton
        disabled={actualValue === value}
        onClick={handleSubmitClick}
        className="voa_feedback_confirm_button"
      >
        {theme?.themeConfig?.chatMessages?.botMessage?.feedback?.feedbackForm?.submitButton?.text}
      </FeedbackFormSubmitButton>
    </FeedbackFormContainer>
  );
});
